var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConWinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1L9.89267 5.39497L14.6574 5.83688L11.0624 8.99503L12.1145 13.6631L8 11.22L3.8855 13.6631L4.9376 8.99503L1.3426 5.83688L6.10733 5.39497L8 1Z",
    fill: "#EF6525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConWinner);
export default __webpack_public_path__ + "static/media/conWinner.bb714bef554e9d0bcdb1c7f23bdb4f3a.svg";
export { ForwardRef as ReactComponent };